import { createAction, props } from '@ngrx/store';
import { EquipmentFilter, EquipmentProduct, EquipmentTapInformation } from 'src/app/models/equipment.model';
import { ODataParams, ODataResponse } from 'src/app/models/odata-response.model';

const id = '[Equipment]';

export const loadEquipments = createAction(`${id} Load Equipments`, props<{ q: ODataParams }>());
export const loadEquipmentsSuccess = createAction(`${id} Load Equipments Success`, props<{ data: any }>());
export const loadEquipmentsFailure = createAction(`${id} Load Equipments Failure`, props<{ error: any }>());

export const loadTapSizes = createAction(`${id} load tap sizes`);
export const loadTapSizesSuccess = createAction(`${id} load tap sizes success`, props<{ res: number[] }>());
export const loadTapSizesFail = createAction(`${id} load tap sizes fail`, props<{ error: any }>());

export const loadTappingMachines = createAction(`${id} load tapping machines`);
export const loadTappingMachinesSuccess = createAction(`${id} load tapping machines success`, props<{ res: EquipmentProduct[] }>());
export const loadTappingMachinesFail = createAction(`${id} load tapping machines fail`, props<{ error: any }>());


export const loadEquipmentTapInformation = createAction(`${id} load tap info`);
export const loadEquipmentTapInformationSuccess = createAction(`${id} load tap info success`, props<{ result: ODataResponse<EquipmentTapInformation[]> }>());
export const loadEquipmentTapInformationFail = createAction(`${id} load tap info fail`, props<{ error: any }>());

export const updateFilter = createAction(`${id} update filter`, props<{ obj: Partial<EquipmentFilter> }>());
